import { Component, Input, OnInit } from "@angular/core";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import {
    Validators,
    FormsModule,
    ReactiveFormsModule,
} from "@angular/forms";
import {
    NgbActiveModal,
    NgbInputDatepicker,
    NgbDateParserFormatter,
    NgbDate,
} from "@ng-bootstrap/ng-bootstrap";
import {
    FormBuilder,
} from "@angular/forms";
import { Sow } from "src/app/core/models/sow";
import { TypedFormGroup } from "src/app/shared-utils/typed-forms.helper";
import { NgbDateCustomParserFormatter } from "src/app/core/Util/ngb-date-parser-customer-formatter";
import { SowApiService } from "src/app/core/api/sow-api.service";
import { convertToDate } from "src/app/core/Util/util";
import { CommonModule } from "@angular/common";
import { ToastrService } from "ngx-toastr";

@Component({
    selector: "app-create-sow-modal",
    standalone: true,
    imports: [
        TranslatePipe,
        FormsModule,
        ReactiveFormsModule,
        NgbInputDatepicker,
        CommonModule
    ],
    providers: [
        {
            provide: NgbDateParserFormatter,
            useClass: NgbDateCustomParserFormatter,
        },
    ],
    templateUrl: "./create-sow-modal.component.html",
    styleUrl: "./create-sow-modal.component.scss",
})
export class CreateSowModalComponent implements OnInit {
    @Input() public contractId : number;
    public isCellEditing = false;
    getRowStyle: any;

    public SowDataForm: TypedFormGroup<Partial<Sow>>;
    constructor(
        private formBuilder: FormBuilder,
        private activeModal: NgbActiveModal,
        private sowApiService: SowApiService,
        private translateService: TranslateService,
        private toastrService: ToastrService

    ) {}

    private buildForm() {
        this.SowDataForm = this.formBuilder.group({
            id: [null],
            po: ["", [Validators.required]],
            caseNumber: ["", [Validators.required]],
            budget: [""],
            startDate: [null, [Validators.required]],
            endDate: [null, [Validators.required]],
            comment: [""],
        }) as TypedFormGroup<Partial<Sow>>;;
    }

    ngOnInit() {
        this.buildForm();
    }

    onSave() {
        if (this.SowDataForm.invalid) {
            this.SowDataForm.markAllAsTouched();
            return;
        }
        if (this.contractId === 0) {
            return;
        }

        const formValue = this.SowDataForm.value;
        const postData: Sow = {
            id: formValue.id ?? 0,
            contractId: this.contractId,
            po: formValue.po,
            caseNumber: formValue.caseNumber,
            budget: formValue.budget,
            comment: formValue.comment,
            endDate: convertToDate(formValue.endDate as unknown as NgbDate),
            startDate: convertToDate(formValue.startDate as unknown as NgbDate),
        };
        this.sowApiService
            .createSow(postData)
            .subscribe({
                next: (response) => {
                    this.activeModal.close(response);
                    this.translateService.get('sow.form.sowCreated').subscribe((res:string) => {
                        this.toastrService.success(res)
                    })
                     this.activeModal.close(response);
                },
                error: () => {
                this.translateService.get('sow.form.sowCreatedError').subscribe((res: string) => {
                    this.toastrService.error(res);
                });
            }
            })
    }

    onClose() {
        this.activeModal.dismiss();
    }
}
